import { FC, memo, PropsWithChildren } from 'react';

import { Canvas } from '@react-three/fiber';
import * as THREE from 'three';

import { colors } from '@ui';

import { FOV } from './CameraControls';
import * as css from './ElvaVisualizer.css';
import { SceneLights } from './SceneLights';

export const CanvasScene: FC<PropsWithChildren<Partial<Record<'background', boolean>>>> = ({
    children,
    background = true,
}) => {
    return (
        <Canvas
            className={css.canvas}
            gl={{ antialias: true }}
            dpr={1.5}
            raycaster={new THREE.Raycaster()}
            camera={{ fov: FOV }}
        >
            {background && <color attach="background" args={[colors.bluegray[100]]} />}
            <SceneLights />
            {children}
        </Canvas>
    );
};

export const MemoCanvasScene = memo(CanvasScene);
